module.exports = ".infoText {\n  font-family: 'Open Sans','Open Sans Hebrew','Open Sans' !important;\n  font-size: 17px; }\n\n.labels {\n  font-weight: bold;\n  color: fuchsia; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/component/map/map.component.scss
// module id = ./src/app/component/map/map.component.scss
// module chunks = main